var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',[_c('AppLayout',[_c('router-view',{key:_vm.$route.path})],1),(_vm.shouldScoreRender)?_c('BaseScoreDialog'):_vm._e(),(_vm.shouldScoreLdpRender)?_c('BaseScoreDialog'):_vm._e(),_c('BaseSnackbar')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }